import React, { useEffect, useRef } from 'react'
import View from './view.js'
import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export default function Logic(props) {
  let app = useDataValue({
    context: 'app',
    viewPath: props.viewPath,
  })
  let submitApp = useDataSubmit({
    context: 'app',
    viewPath: props.viewPath,
  })
  let submitTab = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let flowSet = useRef({
    properties: false,
    connection: false,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  useEffect(() => {
    if (!app) {
      submitTab({ type: 'back/apps' })
      return
    }

    if (app.properties && !flowSet.current.properties) {
      flowSet.current.properties = true

      let missingProperties =
        !app.company.properties ||
        app.properties.some(
          item => item.required && !(item.key in app.company.properties)
        )

      if (missingProperties) {
        setFlowTo(
          normalizePath(props.viewPath, '../Properties/Content/Content')
        )
        return
      }
    }

    if (app.connection && !flowSet.current.connection) {
      flowSet.current.connection = true

      if (app.connections.length === 0) {
        switch (app.connection.type) {
          case 'API_TOKEN': {
            if (app.connection.token) {
              submitApp({ type: 'connect-api-token' })
            } else {
              setFlowTo(
                normalizePath(
                  props.viewPath,
                  '../Connections/Content/AddAction/ApiToken'
                )
              )
            }
            return
          }

          case 'HTTP_JWT': {
            submitApp({ type: 'connect-http-jwt' })
            return
          }

          case 'OAUTH2':
          case 'OAUTH2_AUTHORIZATION_CODE': {
            setFlowTo(
              normalizePath(
                props.viewPath,
                '../Connections/Content/AddAction/OAuth2'
              )
            )
            return
          }

          case 'OAUTH2_CLIENT_CREDENTIALS': {
            submitApp({ type: 'connect-oauth2-client-credentials' })
            return
          }

          default: {
            return
          }
        }
      }
    }
  }, [])

  return <View {...props} />
}
